import {
  TrackerWrapper,
  WelcomeTitle,
  WelcomeSubTitle,
  BenefitsTitle,
  BenefitsList,
  BenefitsItem,
  BenefitsInfo,
  TryTrackerBtn,
  TryTrackerLink,
  IconBox,
} from './WaterTracker.styled';
import Icon from 'components/common/Icon';
import { color } from 'styles/colors';

const WelcomeTracker = () => {
  return (
    <TrackerWrapper>
      <WelcomeTitle>Water consumption tracker</WelcomeTitle>
      <WelcomeSubTitle>Record daily water intake and track</WelcomeSubTitle>
      <BenefitsTitle>Tracker Benefits</BenefitsTitle>
      <BenefitsList>
        <BenefitsItem>
          <IconBox>
            <Icon
              name={'calendar'}
              width={'100%'}
              height={'100%'}
              stroke={color.primary.blue}
            ></Icon>
          </IconBox>
          <BenefitsInfo>Habit drive</BenefitsInfo>
        </BenefitsItem>
        <BenefitsItem>
          <IconBox>
            <Icon
              name={'graphic'}
              width={'100%'}
              height={'100%'}
              stroke={color.primary.blue}
            ></Icon>
          </IconBox>
          <BenefitsInfo>View statistics</BenefitsInfo>
        </BenefitsItem>
        <BenefitsItem>
          <IconBox>
            <Icon
              name={'tools'}
              width={'100%'}
              height={'100%'}
              stroke={color.primary.blue}
            ></Icon>
          </IconBox>
          <BenefitsInfo>Personal rate setting</BenefitsInfo>
        </BenefitsItem>
      </BenefitsList>
      <TryTrackerBtn>
        <TryTrackerLink to="/signup">Try Tracker</TryTrackerLink>
      </TryTrackerBtn>
    </TrackerWrapper>
  );
};

export default WelcomeTracker;
